



































import { Vue, Component, Watch } from 'vue-property-decorator';
import { getDetail } from '../api';
import VoteButton from '../components/VoteButtonNew.vue';
@Component({
  components: { VoteButton },
})
export default class Detail extends Vue {
  voteNum = '';
  voteName = '2023project/q4/2023manufactureThird';
  detailData: any = {};
  async activated() {
    const res = await getDetail(this.$route.query.id);
    this.detailData = res.data;
    this.voteNum = this.detailData.votes;
  }
  votSuccess(data: any) {
    this.voteNum = data;
  }
  returnPage() {
    this.$router.push({ path: 'home' });
  }
}
